import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import { CYSUMemberInformationForm } from "webapp/components/Partner/CYSU/CYSUMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";
import { GKWMemberInformationForm } from "webapp/components/Partner/GKW/GKWMemberInformationForm";

function GKWMemberInformation(props) {
  const { t } = useTranslation();
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [hasSelectedContact, setHasSelectedContact] = useState(false);
  const [showSelectError, setShowSelectError] = useState(false);
  const [showMNFInputError, setShowMNFInputError] = useState(false);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [showNotCoveredMsg, setShowNotCoveredMsg] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const [acceptOOPConsent, setAcceptOOPConsent] = useState(false);
  const [MNFMemberInfoData, setMNFMemberInfoData] = useState({
    firstName: props.currState.MemberLookup.firstName || props.currState.FirstName || "",
    lastName: props.currState.MemberLookup.lastName || props.currState.LastName || "",
    phoneNumber: props.currState.MemberLookup.phoneNumber || props.currState.Number || "",
    memberNumber: props.currState.MemberLookup.memberNumber || "",
    last8Vin: props.currState.MemberLookup.last8Vin || "",
    purchaseDate: "",
    havingTrouble: false,
    covered: false,
  });
  const [lookupSucceeded, setLookupSucceeded] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = (forceAcceptOOP = false) => {
    devLog("onUserNext", selectedContact);
    devLog("onUserNext MNFMemberInfoData", MNFMemberInfoData);

    const isMNFInputInValid =
      MNFMemberInfoData.havingTrouble &&
      (MNFMemberInfoData.firstName === "" ||
        MNFMemberInfoData.lastName === "" ||
        MNFMemberInfoData.phoneNumber === "" ||
        MNFMemberInfoData.memberNumber === "" ||
        MNFMemberInfoData.last8Vin === "" ||
        MNFMemberInfoData.purchaseDate === "");

    devLog("isMNFInputInValid", isMNFInputInValid);

    if (isMNFInputInValid) {
      setShowMNFInputError(true);
      setShowSelectError(false);
      return;
    }

    if (!MNFMemberInfoData.havingTrouble && !hasSelectedContact) {
      devLog(
        "!MNFMemberInfoData.havingTrouble && !hasSelectedContact",
        !MNFMemberInfoData.havingTrouble && !hasSelectedContact,
      );
      setShowSelectError(true);
      setShowSelectUserModal(true);
      setShowMNFInputError(false);
      return;
    }

    if (hasSelectedContact && !MNFMemberInfoData.havingTrouble) {
      const contactOrAccount = selectedContact || memberInfo;
      // New driver (selectedContact === undefined) uses names from prior state;
      // existing contact uses the selected contact's name.
      const firstName =
        selectedContact?.firstName || props.currState.FirstName || props.currState.MemberLookup?.firstName || "";
      const lastName =
        selectedContact?.lastName || props.currState.LastName || props.currState.MemberLookup?.lastName || "";
      const phoneNumber =
        selectedContact?.phoneNumber || props.currState.Number || props.currState.MemberLookup?.phoneNumber || "";

      props.context.setState(
        {
          accountRef: contactOrAccount?.accountRef || memberInfo?.accountRef,
          contactRef: selectedContact?.contactRef,
          FirstName: firstName,
          LastName: lastName,
          Number: phoneNumber,
          Year: contactOrAccount?.year,
          Make: contactOrAccount?.make,
          Model: contactOrAccount?.model,
          Color: contactOrAccount?.color,
          allowVehicleInfoEdits: false,
          MemberLookup: {
            ...props.currState.MemberLookup,
            firstName,
            lastName,
            phoneNumber,
          },
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else if (!MNFMemberInfoData.covered && !acceptOOPConsent && !forceAcceptOOP) {
      setShowNotCoveredMsg(true);
      return;
    } else if (
      !isMNFInputInValid &&
      MNFMemberInfoData.havingTrouble &&
      (MNFMemberInfoData.covered || acceptOOPConsent || forceAcceptOOP)
    ) {
      devLog("!isMNFInputInValid MNFMemberInfoData", MNFMemberInfoData);
      devLog("MNFMemberInfoData.covered", MNFMemberInfoData.covered);
      props.context.setState(
        {
          MemberLookup: {
            ...MNFMemberInfoData,
            acceptOOPConsent: acceptOOPConsent || forceAcceptOOP,
          },
          FirstName: MNFMemberInfoData.firstName,
          LastName: MNFMemberInfoData.lastName,
          Number: MNFMemberInfoData.phoneNumber,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */

      setShowSelectUserModal(true);
    }
  };

  const onAcceptNotCovered = () => {
    setShowNotCoveredMsg(false);
    setAcceptOOPConsent(true);
    onUserNext(true);
  };

  const promptCancelService = () => {
    setShowCancelConfirm(true);
  };

  const onConfirmCancelService = () => {
    setShowCancelConfirm(false);
    setShowNotCoveredMsg(false);
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onUserCancel = () => {
    promptCancelService();
  };
  const onContractLookupComplete = (success) => {
    setLookupSucceeded(!!success);
    if (!success) {
      setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: false }));
    }
  };

  const onHavingTroubleChange = (havingTrouble) => {
    setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: !!havingTrouble }));
  };

  const onUserSelectMember = (accountInfo, contactInfo) => {
    devLog("onUserSelectMember", accountInfo, contactInfo);
    setMemberInfo(accountInfo);
    setSelectedContact(contactInfo);
    setHasSelectedContact(true);
    setShowSelectError(false);
  };

  const shouldShowFooter = lookupSucceeded || MNFMemberInfoData.havingTrouble;

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("APIA.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <GKWMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onSelect={onUserSelectMember}
          onHavingTroubleChange={onHavingTroubleChange}
          showSelectError={showSelectError}
          MNFMemberInfoData={MNFMemberInfoData}
          setMNFMemberInfoData={setMNFMemberInfoData}
        />
      </div>

      {shouldShowFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
      {showMNFInputError && (
        <Dialog
          title={"ErrorMNFInput"}
          message={"ErrorMNFInputMsg"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowMNFInputError(false);
          }}
        />
      )}

      {showNotCoveredMsg && (
        <Dialog
          title={"CoverageExpired"}
          message={"CoverageExpiredMsg"}
          buttonTitle={"CancelCallButton4"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Accept"}
          secondaryButtonAction={onAcceptNotCovered}
          preventDismiss={true}
          onClose={() => {
            setShowNotCoveredMsg(false);
          }}
        />
      )}

      {showCancelConfirm && (
        <Dialog
          title={"CancelCall1"}
          message={"CancelCall2"}
          buttonTitle={"No"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Yes"}
          secondaryButtonAction={onConfirmCancelService}
          onClose={() => {
            setShowCancelConfirm(false);
          }}
        />
      )}
    </>
  );
}

export default GKWMemberInformation;
